// ----------------------------------------------------------------------------- //
//  Mobile navigation
// ----------------------------------------------------------------------------- //
document.addEventListener("DOMContentLoaded", function () {



	const masthead = document.getElementById("masthead");
	const siteNavigation = document.getElementById("mobile_navigation");
	const siteNavigationTrigger = document.querySelectorAll('button[aria-controls="mobile_navigation"]');

	if ( siteNavigation && siteNavigationTrigger.length ) {
		siteNavigationTrigger.forEach( (btn) => {
			btn.addEventListener("click", () => {
				const btns = document.querySelectorAll('button[aria-controls="mobile_navigation"]');
				if ( btns.length ) {
					if ( siteNavigation.getAttribute("aria-hidden") == "true" ) {
						document.body.classList.add("overflow-hidden");
						btns.forEach((i) => {
							i.setAttribute("aria-expanded", "true");
						});
						masthead.classList.add("is-mobile-navigation-expanded");
						siteNavigation.setAttribute("aria-hidden", "false");
					} else {
						document.body.classList.remove("overflow-hidden");
						btns.forEach((i) => {
							i.setAttribute("aria-expanded", "false");
						});
						masthead.classList.remove("is-mobile-navigation-expanded");
						siteNavigation.setAttribute("aria-hidden", "true");
					}
				}
			});
		});
		// Dodanie obsługi kliknięcia na linkach w nawigacji
		document.querySelectorAll('#mobile_navigation a').forEach(link => {
			link.addEventListener('click', () => {
				// Zamknij mobilną nawigację
				document.body.classList.remove("overflow-hidden");
				const btns = document.querySelectorAll('button[aria-controls="mobile_navigation"]');
				btns.forEach((i) => {
					i.setAttribute("aria-expanded", "false");
				});
				if (siteNavigation) {
					siteNavigation.setAttribute("aria-hidden", "true");
				}
				if (masthead) {
					masthead.classList.remove("is-mobile-navigation-expanded");
				}
			});
		});


	}
});
